<h3 class="mt-5">Especificações Técnicas</h3>
<hr />

<div class="d-flex flex-column pb-3 pt-3">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">
      Marcação
    </h3>

    <div class="d-flex col-6">
      <app-dimension-information
        style="margin-top: -16px"
        class="mb-2 w-100"
        [signType]="signalingType"
        [dimensionInformationState]="{
          dimensionType: horizontalSignaling?.dimensionType,
          dimension: horizontalSignaling?.dimension,
          dimensionX: horizontalSignaling?.dimensionX,
          dimensionY: horizontalSignaling?.dimensionY,
          units: horizontalSignaling?.units,
          quantity: horizontalSignaling?.quantity,
          dash: horizontalSignaling?.dash,
          spacing: horizontalSignaling?.spacing
        }"
        [displayDirection]="'row'"
        [idSign]="horizontalSignaling?.id"
        [signCode]="horizontalSignaling?.signCode"
        [projectSignalingItemId]="horizontalSignaling?.projectSignalingItemId"
        [switchId]="currentSignIndex"
        (dimensionInformationEmmitter)="handleDimensionInformation($event)"
      >
      </app-dimension-information>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3" *ngIf="horizontalSignaling?.contract?.id && !financialSignalingValue">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3"></h3>
    <div class="d-flex col-6">
      <div class="col-12 p-0">
        <label>{{ horizontalSignaling?.project?.id ? 'Item do Projeto*' : 'Item do Contrato*' }}</label>

        <select
          class="form-control"
          (change)="onChangeItemContract()"
          [(ngModel)]="horizontalSignaling.contractSignItemId"
          [ngClass]="{ 'select-readonly': roadLocked }"
        >
          <option value="" hidden>Selecione o item</option>
          <option
            *ngFor="let roadItem of contractRoadItems"
            [value]="roadItem?.id"
            [hidden]="signalingType == typeSignEnum.Device && roadItem.signaling != horizontalSignaling?.signCode"
          >
            {{ roadItem.code ? roadItem.code + ' - ' : '' }}{{ roadItem.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">
      Data de Execução
    </h3>

    <div class="position-relative col-6">
      <label for="execution">Data de Execução</label>
      <input
        bsDatepicker
        class="form-control cursor-pointer"
        [ngModel]="dateService.TransformDate({ warranty: horizontalSignaling?.executionDate }, 'get')"
        (bsValueChange)="setExecutionDate($event, signalingType)"
        [bsConfig]="{
          isAnimated: true,
          containerClass: 'theme-dark-blue',
          dateInputFormat: 'DD-MM-YYYY',
          showWeekNumbers: false
        }"
      />
      <i class="fa-solid fa-calendar position-absolute" style="right: 4%; top: 58%; pointer-events: none"></i>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3" *ngIf="horizontalSignaling?.contract?.id && !financialSignalingValue">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3"></h3>
    <div class="d-flex col-6">
      <div class="col-12 p-0">
        <h4 class="text-muted" style="color: var(--gray-base)">Material Aplicado</h4>
        <p>{{ roadItemText() }}</p>
      </div>
    </div>
  </div>
</div>

<!-- Cor de aplicação (somente LCO) -->
<div
  class="d-flex flex-column pb-3 pt-3"
  *ngIf="horizontalSignaling?.horizontalCode === horizontalSignalingEnum.LCO"
>
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">
      Cor de aplicação
    </h3>

    <div class="d-flex col-6">
      <div class="col-12 p-0">
        <label>Cor de aplicação</label>
        <select
          class="form-control"
          [(ngModel)]="horizontalSignaling.color"
          (ngModelChange)="handleApplicationColor($event)"
        >
          <option [ngValue]="undefined" hidden>Selecione</option>
          <option [ngValue]="applicationColorEnum.White">Branco</option>
          <option [ngValue]="applicationColorEnum.Yellow">Amarelo</option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">
      Qualidade da Sinalização
    </h3>

    <div class="d-flex col-6">
      <div class="col-12 p-0">
        <label>Qualidade da Sinalização</label>
        <select class="form-control" [(ngModel)]="horizontalSignaling.quality">
          <option value="" hidden>Escolha o estado</option>
          <option *ngFor="let quality of signalingQualityEnum" [value]="quality">
            {{ quality | enumText: 'SignalingQualityEnum' }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3" *ngIf="!horizontalSignaling?.contract?.id">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3"></h3>
    <div class="d-flex col-6">
      <div class="col-12 p-0">
        <label>Material Aplicado</label>
        <select class="form-control" [(ngModel)]="horizontalSignaling.roadSignMarkingPaintId">
          <option value="" hidden>Selecione o item</option>
          <option *ngFor="let paint of markPainting?.roadSignMarkingPaints" [value]="paint?.id">
            {{ paint?.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="d-flex flex-column pb-3 pt-3" *ngIf="!horizontalSignaling?.pathId">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">
      Retrorrefletorização
    </h3>

    <div class="d-flex col-6">
      <div class="col-12 d-flex align-items-center p-0">
        <div class="custom-control-right custom-switch ml-0 mr-2">
          <input
            type="checkbox"
            class="custom-control-input mx-4"
            id="horizontal-info-retro-switch"
            [checked]="switchRetro"
            (click)="$event.preventDefault()"
          />
          <label class="custom-control-label" for="horizontal-info-retro-switch"
            (click)="setRetro(!switchRetro); $event.preventDefault()"></label>
        </div>
        <small class="pt-1" style="font-size: 14px; font-weight: 500">Retrorrefletorização</small>
      </div>
    </div>
  </div>

  <div class="d-flex">
    <div class="col-3"></div>

    <div class="col-6" *ngIf="switchRetro">
      <div class="row mx-0 ml-4 mt-4 mb-2">
        <div class="col pl-0 pr-2">
          <div class="form-group">
            <label for="retroTargetValue">Valor Desejado (mcd Lux/m²)</label>
            <input
              class="form-control"
              name="maximumRetroreflectionValue"
              [(ngModel)]="horizontalSignaling.maximumRetroreflectionValue"
              (change)="emitRetro()"
            />
          </div>
        </div>

        <div class="col pr-0 pl-4">
          <div class="form-group">
            <label for="retroMinValue">Valor Mínimo (mcd Lux/m²)</label>
            <input
              class="form-control"
              name="minimumRetroreflectionValue"
              [(ngModel)]="horizontalSignaling.minimumRetroreflectionValue"
              (change)="emitRetro()"
            />
          </div>
        </div>
      </div>

      <div class="row mx-0 ml-4 my-2">
        <div class="col-auto px-0">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="measure1"
              name="retroMeasure"
              [(ngModel)]="retroreflections.type"
              [value]="retroTypeEnum.Unico"
              class="custom-control-input"
              (change)="emitRetro()"
            />
            <label class="custom-control-label" for="measure1"></label>
          </div>
        </div>

        <div class="col pl-0 pr-2">
          <p class="pt-1 mx-2">Medição Única</p>

          <div class="form-group d-flex align-items-center" *ngIf="retroreflections?.type == retroTypeEnum.Unico">
            <input
              class="form-control w-50 mx-2"
              [class.retro-disabled]="retroreflections?.type == retroTypeEnum.Segmentado"
              type="number"
              placeholder="Insira o valor aqui"
              id="retroTargetValue"
              name="singleMeasurement"
              [(ngModel)]="retroreflections.measurements[0].value"
              (ngModelChange)="emitRetro()"
            />
            <p class="mb-0 mx-2">mcd/Lux m²</p>
          </div>
        </div>
      </div>

      <div class="row mx-0 ml-4 my-2">
        <div class="col-auto px-0">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="measure2"
              name="retroMeasure"
              [(ngModel)]="retroreflections.type"
              [value]="retroTypeEnum.Segmentado"
              class="custom-control-input"
              (change)="emitRetro()"
            />
            <label class="custom-control-label" for="measure2"></label>
          </div>
        </div>

        <div class="col pl-0 pr-4">
          <p class="pt-1 mx-2">Medição Segmentada</p>

          <div class="d-flex align-items-center justify-content-between" *ngIf="retroreflections?.type == retroTypeEnum.Segmentado">
            <div class="form-group px-2">
              <label for="average">Média (mcd Lux/m²)</label>
              <input
                class="form-control"
                [value]="retroreflections?.average ? retroreflections?.average.toFixed(0) : 0"
                type="number"
                id="average"
                readonly
              />
            </div>

            <div class="col-auto">
              <h4 class="text-primary cursor-pointer" (click)="openModalG(segmentedModal)" style="font-weight: 600">
                CONFIGURAR VALORES
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Garantia -->
<h3 class="mt-5">Garantia Da Sinalização</h3>
<hr />

<div class="d-flex flex-column pb-3 pt-3 mb-4">
  <div class="d-flex">
    <h3 class="d-flex justify-content-end col-3 text-muted" style="font-weight: 400">Data de Expiração</h3>
    <app-warranty-input
      style="min-width: 50%"
      (emitWarrantyValues)="handleWarranty($event)"
      [warranty]="horizontalSignaling.warranty"
      [warrantyLastUpdate]="horizontalSignaling.warrantyLastUpdate"
      [createdAt]="horizontalSignaling.createdAt"
    >
    </app-warranty-input>
  </div>
</div>


<ng-template #segmentedModal>
  <div class="modal-header" style="align-items: center">
    <h3 class="modal-title">Novo Valor Segmentado</h3>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <i aria-hidden="true" class="fas fa-xmark"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="col mx-0 my-2 px-0" style="min-height: 500px">
      <p>
        O Valor Segmentado gera uma média de retrorrefletorização baseado na combinação de várias medições em uma só.
        Abaixo, adicione essas medições na lista, clicando em <i class="fas fa-plus-circle"></i> Novo Valor e o
        resultado da média é mostrado no campo abaixo.
      </p>
      <div class="col-3 d-flex justify-content-end px-0">
        <div class="form-group w-100">
          <label for="average">Média (mcd Lux/m²)</label>
          <input class="form-control" type="number" placeholder="0" id="average"
            [value]="retroreflections?.average ? retroreflections?.average.toFixed(0) : 0" readonly />
        </div>
      </div>
      <div class="scroll-behavior-modal p-1 pr-2">
        <div class="segmented-measure-row"
          *ngFor="let measure of retroreflections?.measurements; index as indexOfMeasure">
          <div class="col-3 pl-0 form-group">
            <label for="measureValue">Medição {{ indexOfMeasure + 1 }}*</label>
            <div class="mcd-group d-flex align-items-center w-100">
              <input class="form-control" type="number" placeholder="0" [value]="measure.value"
                (change)="measure.value = $event.target.value; setRetroAverage(retroreflections?.measurements); emitRetro();" />
              <div class="marking" style="right: 32px">mcd Lux/m²</div>
            </div>
          </div>
          <div class="col-auto form-group px-0" *ngIf="horizontalSignaling.pathId; else elseNoPathBlock">
            <label for="measureValue">Trecho (Início - Fim)</label>
            <div class="row mx-0 d-flex align-items-center">
              <div class="col px-0 pr-1">
                <select name="startKm" id="startKm" class="form-control" [(ngModel)]="measure.startsAt">
                  <option [value]="marker.kilometer" *ngFor="let marker of horizontalSignaling.path.markers">
                    {{ marker.kilometer }}
                  </option>
                </select>
              </div>
              <div class="col px-0 pl-1">
                <select name="endKm" id="endKm" class="form-control" [(ngModel)]="measure.endsAt">
                  <option [value]="marker.kilometer" *ngFor="let marker of horizontalSignaling.path.markers">
                    {{ marker.kilometer }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <ng-template #elseNoPathBlock>
            <div class="col-2 form-group px-0">
              <label for="measureValue">Trecho (Início - Fim)</label>
              <div class="row mx-0 d-flex align-items-center">
                <div class="col px-0 pr-1">
                  <input type="number" name="startKm" id="startKm" class="form-control"
                    [(ngModel)]="measure.startsAt" />
                </div>
                <div class="col px-0 pl-1">
                  <input type="number" name="endKm" id="endKm" class="form-control" [(ngModel)]="measure.endsAt" />
                </div>
              </div>
            </div>
          </ng-template>

          <div class="col">
            <div class="form-group">
              <label for="distance">Distância (m)</label>
              <input type="number" name="distance" [(ngModel)]="measure.distance" placeholder="0" class="form-control"
                (click)="emitRetro()" />
            </div>
          </div>
          <div class="col px-0">
            <div class="form-group">
              <label for="latitude">Latitude</label>
              <input type="number" name="latitude" [(ngModel)]="measure.latitude" placeholder="0" class="form-control"
                (click)="emitRetro()" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="longitude">Longitude</label>
              <input type="number" placeholder="0" [(ngModel)]="measure.longitude" name="longitude" class="form-control"
                (click)="emitRetro()" />
            </div>
          </div>
          <button class="btn btn-icon btn-icon-alt align-self-bottom mt-2" (click)="removeMeasure(indexOfMeasure)"
            [disabled]="retroreflections.measurements.length <= 1">
            <i class="fas fa-x text-danger"></i>
          </button>
        </div>
        <div class="form-group d-flex align-items-center">
          <button class="btn btn-link" (click)="setMeasure(); emitRetro()"
            [disabled]="retroreflections['measurements'].length > 9">
            <i class="fas fa-plus-circle"></i>
            novo valor
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="closeModal()">cancelar</button>
    <button class="btn btn-primary" (click)="saveSegmentedRetro(retroreflections); closeModal(); retroChanged = true">
      aplicar
    </button>
  </div>
</ng-template>
